import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';

const hasActiveFulfillmentWithCustomsForms = (fulfillments = []) =>
  fulfillments
    .filter((f) => !f.isLabelVoided)
    .some(({ labelFulfillment }) => {
      const hasCustomsForm = !!labelFulfillment?.hasCustomsFormFile;
      return hasCustomsForm;
    });

const doesAnyFpHaveCustomsInfo = (fulfillmentPlans = []) =>
  fulfillmentPlans.some(({ customs, international }) => {
    const fpHasCustomsItems = !!customs?.customsItems?.length;

    if (!fpHasCustomsItems) {
      return false;
    }

    return !!international?.needsCustoms;
  });

export const useCanUserPrintCustomsForms = (fulfillmentPlanIds) => {
  return useSelector((state) => {
    const userHasShippingRole = Global.selectUserhasShippingRole(state);
    if (!userHasShippingRole) {
      return false;
    }

    const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, {
      fulfillmentPlanIds,
    });
    const hasCustomsInfo = doesAnyFpHaveCustomsInfo(fulfillmentPlans);

    if (!hasCustomsInfo) {
      return false;
    }

    const fulfillments = Global.selectEntitiesFulfillmentsByFulfillmentPlanIds(state, { fulfillmentPlanIds });

    return hasActiveFulfillmentWithCustomsForms(fulfillments);
  });
};

export const useCanUserPrintOtherForms = (fulfillmentPlanIds) => {
  return useSelector((state) => {
    const userHasShippingRole = Global.selectUserhasShippingRole(state);
    if (!userHasShippingRole) {
      return false;
    }

    const fulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, {
      fulfillmentPlanIds,
    });
    const hasCustomsInfo = doesAnyFpHaveCustomsInfo(fulfillmentPlans);

    if (hasCustomsInfo) {
      return false;
    }

    const fulfillments = Global.selectEntitiesFulfillmentsByFulfillmentPlanIds(state, { fulfillmentPlanIds });

    return hasActiveFulfillmentWithCustomsForms(fulfillments);
  });
};
